<template>
  <div class="switcher">
    <SwitchSideButton
      v-for="(type, key) in JACKET_SIDES"
      :key="key"
      :type="type"
      :is-active="type === side"
      @onSwitch="onChangeJacketSide"
    />
  </div>
</template>

<script>
import SwitchSideButton from '@/components/jacket/SwitchSideButton.vue';
import { JACKET_SIDES } from '@/common/constants';

export default {
  name: 'JacketViewSwitcher',

  components: {
    SwitchSideButton
  },

  data () {
    return {
      JACKET_SIDES
    };
  },

  computed: {
    side () {
      return this.$store.getters['ui/getJacketSide'];
    }
  },

  methods: {
    onChangeJacketSide (side) {
      this.$store.dispatch('ui/setJacketSide', side);
    }
  }
};
</script>

<style scoped>
  .switcher {
    position: relative;
    z-index: 10;
    display: flex;
    justify-content: center;
    margin-top: auto;
  }
</style>
